import React from 'react';
import {Grid} from '@mui/material';
import { IGridSize, IGridCardRowProps, IHeaderItem } from './interfaces';
import { defaultGridSize } from './data';
import GridCardItem from './GridCardItem';

/**
 *
 * @param data The data to display
 * @param headData
 * @param gridSize
 * @param rowStyles
 * @param labelStyles
 * @param valueStyles
 * @param elementStyleActive
 * @param elementStyles
 * @constructor
 * @deprecated
 **/

const GridCardRow = ({
  data,
  headData,
  gridSize,
  rowStyles,
  labelStyles,
  valueStyles,
  elementStyleActive,
  elementStyles,
}: IGridCardRowProps) => {
  const filteredEntries = headData.filter((header) => !header?.hideWhen || !header.hideWhen(data[header.id], data));
  const hasEntries = !!filteredEntries.length;

  const itemGridSize: IGridSize = {
    ...defaultGridSize,
    ...gridSize,
  };
  return (
    <Grid spacing={2} container sx={{
      //margin: 0,
      ...(rowStyles && rowStyles)
    }} >
      {hasEntries && filteredEntries.map((headerItem: IHeaderItem) => (
        <GridCardItem
          key={headerItem.id}
          icon={headerItem.icon}
          label={headerItem.label}
          value={headerItem.formatter ? headerItem.formatter(data[headerItem.id], data) : data[headerItem.id]}
          data={data}
          listId={headerItem.id}
          gridSize={{
            ...itemGridSize,
            ...(headerItem.gridSize && headerItem.gridSize)
          }}
          onClick={headerItem.onClick}
          labelStyles={labelStyles}
          valueStyles={valueStyles}
          elementStyleActive={elementStyleActive}
          elementStyles={elementStyles}
        />
      ))}
    </Grid>
  );
};

export default GridCardRow;